<template>
  <b-container class="massima">

    <loading :active.sync="loading" 
      :can-cancel="false"
      :is-full-page="true"></loading>

    <Menu></Menu>

    <b-row class="mt-4">
        <b-col sm="2"></b-col>
        <b-col sm="8">
            <b-row class="text-center">
                <b-col cols="8" class="text-left mt-2">
                    <router-link :to="{ name: 'Profilo', params: { codFisc: massima.codFisc } }" class="text-decoration-none">
                        <img :src="imgLink" width="25" />&nbsp;&nbsp;
                        <b class="text-uppercase">{{massima.avvocato}}</b>
                    </router-link>
                    (Redattore della Massima)
                </b-col>
                <b-col cols="4" class="text-right mt-2">
                    <small class="text-muted">Pubblicato il {{data}}</small>
                </b-col>
                <b-col cols="12" class="mt-2 pt-2" style="background-color: #008bc0;">
                    <router-link :to="{ name: 'Sentenza', params: { idNodo: massima.sentenzaId } }">
                        <b><h5 style="color: white">{{massima.sentenzaTitolo}}</h5></b>
                    </router-link>
                </b-col>
                <b-col cols="12">
                    <b>Materia: {{massima.sentenzaMateria}}</b><br/>
                    <b>Sottomateria: {{massima.sentenzaSottoMateria}}</b>
                    <br/>
                    <b-button :to="{ name: 'Sentenza', params: { idNodo: massima.sentenzaId } }" variant="outline-danger" class="mt-2">
                      <font-awesome-icon icon="file-pdf" />
                      Visualizza la sentenza <br/>
                      (riservato agli iscritti)
                    </b-button>
                </b-col>
                <b-col class="mt-2 pt-2 font-weight-bold" cols="12"
                    style="background-color: #c1f3ff; border: 4px solid #008bc0; border-bottom: none">
                    <b>SINTESI</b>
                    <div v-html="massima.premassima">
                    </div>
                </b-col>
                <b-col class="pt-2" cols="12" style="border: 4px solid #008bc0;">  
                    <b>MASSIMA</b>  
                    <div class="massima-text text-justify" v-html="massima.testo">
                    </div>  
                </b-col>

            </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '../../services/service.js'
import utils from '../../services/utils.js';

import Menu from './Menu.vue';

export default {
  name: 'massima',
  components: {
    Loading,
    Menu
  },
  data () {
    return {
        loading: false,
        idCommento: this.$route.params.idMassima,
        massima: {},
        imgLink: '',
        data: ''
    }
  },
  methods: {
    async getMassima() {
        this.massima = await api.execute('get', 'commento/id/' + this.idCommento);

        this.imgLink = utils.getAvatarUrl(this.massima.codFisc);
        this.data = utils.formatDate(new Date(this.massima.dataInserimento));
    }
  },
  async created() {
    await this.getMassima();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
.massima-text p{
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pubblica/Massima.vue